export const ColorSpecialties: Record<number | string, string> = {
  0: '#6c757d',    // Gray (Default / Fallback)
  1: '#ffc107',    // Yellow
  2: '#28a745',    // Green
  3: '#007bff',    // Blue
  4: '#dc3545',    // Red
  5: '#17a2b8',    // Teal
  6: '#ff00ff',    // Magenta
} as const;

export default ColorSpecialties;